export const WIDTH_ACTION_CELL = 60;

export const WIDTH_DATE_CELL = 100;

export const WIDTH_DATE_TIME_CELL = 180;
